import Grid from "@material-ui/core/Grid";
import moment from "moment";
import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { userFarmDetail } from "../../../config/farmDetails";
import DropdownOptions from "../../../constants/DropdownOptions";
import {
  emptyStateOnReconciliation,
  getReconciledTicketDetails,
  getTicketDetails,
  getTicketList
} from "../../../modules/reconciliation/action";
import Forbidden from "../../../template/private/Forbidden";
import AllMainFarmSelectedDialog from "../../Common/AllMainFarmSelectedDialog";
import {
  hasValidPlan,
  isAuthorized,
  isSuperAdmin,
  isCounterParty
} from "../../Common/CheckAuthorization";
import DataRangePicker from "../../FormElement/DatePickerRange";
import Dropdown from "../../FormElement/Dropdown";
import { validForm } from "../../FormElement/FormValidator";
import SubMenu from "../../private/SubMenu";
import RecievedDetails from "./RecievedDetails";
import TicketDetails from "./TicketDetails";
import  "../../../style/main.css";
import Comingsoonpath from "../../../assets/images/coming soon.jpg";
class Reconciliation extends Component {
  constructor(props) {
    super(props);
    this.state = {
      ticketList: [],
      ticketListId: "",
      ticketDetails: [],
      isValid: true,
      reconciled: "",
      formErrors: {
        ticketList: ""
      },
      ReconciledData: [],

      startDate: "",
      endDate: "",
      SubFarmId: "",
      selectedYear: "",
      status: [
        { id: "Reconciled", name: "Reconciled" },
        {
          id: "Reconciled with Net Shrunk Payload Bushels",
          name: "Reconciled with Net Shrunk Payload Bushels"
        },
        { id: "Not Reconciled", name: "Not Reconciled" },
        { id: "All Tickets", name: "All Tickets" }
      ],
      selectedStatus: "All Tickets",
      clearError: false
    };
  }
  componentWillMount() {
    if (
      (!isSuperAdmin() && hasValidPlan()) ||
      this.props.MainFarmId !== DropdownOptions.ALL_MAIN_FARM.id
    ) {
      this.props.actions.getTicketList(
        "",
        "",
        this.props.SubFarmId || userFarmDetail().id || this.props.MainFarmId,
        this.props.selectedYear
      );
    }
  }
  componentWillReceiveProps(nextProps) {
    if (
      nextProps.getTicketList &&
      nextProps.getTicketList !== this.props.getTicketList
    ) {
      this.setState({
        ticketList: nextProps.getTicketList
      });
    }

    if (
      nextProps.getTicketDetails &&
      nextProps.getTicketDetails !== this.props.getTicketDetails
    ) {
      this.setState(
        {
          ticketDetails: nextProps.getTicketDetails,
          reconciled:
            nextProps.getTicketDetails.status &&
            nextProps.getTicketDetails.status.name,
          isValid: false,
          ReconciledData: {
            receivedcommodity: nextProps.getTicketDetails.commodity,
            receivedcommodityVariety:
              nextProps.getTicketDetails.commodityVariety,
            shrinkReconciliation: nextProps.getTicketDetails.shrinkMultiplier
          }
        },
        () => {
          console.log(this.state.ReconciledData.receivedcommodityVariety);
        }
      );
      // this.setState({
      //   reconciled:
      //     nextProps.getTicketDetails.status &&
      //     nextProps.getTicketDetails.status.name
      // });
      // this.setState({
      //   isValid: false
      // });
    }

    if (
      nextProps.reconciledData &&
      nextProps.reconciledData !== this.props.reconciledData
    ) {
      this.setState({
        ReconciledData: nextProps.reconciledData
      });
    }

    if (
      nextProps.SubFarmId &&
      nextProps.SubFarmId !== this.props.SubFarmId &&
      nextProps.SubFarmId !== DropdownOptions.ALL_MAIN_FARM.id
    ) {
      this.setState({
        SubFarmId: nextProps.SubFarmId
      });
      this.props.actions.getTicketList(
        "",
        "",
        nextProps.SubFarmId,
        nextProps.selectedYear
      );
    }

    if (
      nextProps.selectedYear &&
      nextProps.selectedYear !== this.props.selectedYear
    ) {
      this.props.actions.getTicketList(
        "",
        "",
        this.props.SubFarmId || userFarmDetail().id || this.props.MainFarmId,
        nextProps.selectedYear
      );
    }

    if (Object.keys(nextProps.getTicketDetails || []).length === 0) {
      this.setState({
        // selectedStatus : "",
        ticketListId: ""
      });
    }
  }

  handleChange = event => {
    const { name, type, value } = event.target;
    this.setState(
      {
        [name]: value,
        formErrors: {
          ticketList: ""
        }
      },
      () => {
        if (name === "ticketListId")
          this.props.actions.getTicketDetails(value).then(data => {
            if (data) {
              this.setState({ clearError: true });
              this.props.actions.getReconciledTicketDetails(value);
            }
          });
        else if (name === "selectedStatus") {
          // this.props.actions.getTicketList(
          //   this.state.startDate,
          //   this.state.endDate,
          //   this.props.SubFarmId ||
          //     userFarmDetail().id ||
          //     this.props.MainFarmId,
          //   this.props.selectedYear
          // );
          this.props.actions.emptyStateOnReconciliation();
          this.setState({ clearError: true });
        }
      }
    );
  };
  handleError = (name, error) => {
    this.setState(
      prevState => {
        return {
          formErrors: {
            ...prevState.formErrors,
            [name]: error
          }
        };
      },
      () => {
        this.setState({
          isValid: validForm(this.state.formErrors)
        });
      }
    );
  };

  onRangeSelect = range => {
    const { start, end } = range;
    if (range) {
      this.setState(
        {
          startDate: new Date(moment(start._d).format()).toISOString(),
          endDate: new Date(moment(end._d).format()).toISOString()
        },
        () => {
          this.props.actions.emptyStateOnReconciliation();
          this.props.actions.getTicketList(
            this.state.startDate,
            this.state.endDate,
            this.state.SubFarmId
              ? this.state.SubFarmId
              : userFarmDetail().id || this.props.MainFarmId,
            this.props.selectedYear
          );
          // this.props.actions.getTicketList(
          //   "",
          //   "",
          //   this.props.SubFarmId || userFarmDetail().id
          // );
        }
      );
    }
  };

  showTicketList = () => {
    const { ticketList, selectedStatus, status } = this.state;
    let list = [];
    if (selectedStatus === "Reconciled") {
      list = ticketList.filter(
        item =>
          item.status &&
          item.status.name === "Reconciled" &&
          item.usesShrunkPayloadBushels === false
      );
      console.log(list, "hh");
    } else if (selectedStatus === "Not Reconciled")
      list = ticketList.filter(item => item.status === null);
    else if (selectedStatus === "Reconciled with Net Shrunk Payload Bushels") {
      list = ticketList.filter(
        item =>
          item.status &&
          item.status.name === "Reconciled" &&
          item.usesShrunkPayloadBushels === true
      );
      console.log(list);
    } else {
      list = ticketList;
    }
    list.map(data => {
      data.name = `${data.ticketNumber} [${data.loadNumberIndValue}]`;
    });
    console.log(list);

    return list;
  };

  render() {
    const {
      ticketList,
      ticketListId,
      ticketDetails,
      isValid,
      formErrors,
      reconciled,
      ReconciledData,
      clearError,
      status
    } = this.state;
    const menuName = "Reconciliation";
    if( isCounterParty() ){
      return <div className="coomingsoonimg"> 
      <img alt="Coming soon"  src={Comingsoonpath} />
      </div>
    }
    return isAuthorized() && hasValidPlan() ? (
      <div>
        <div className="">
          <SubMenu menuName={menuName} />
        </div>
        {isSuperAdmin() &&
        this.props.MainFarmId === DropdownOptions.ALL_MAIN_FARM.id ? (
          <AllMainFarmSelectedDialog />
        ) : (
          <div>
            <div className="textRequired">* Required Cells</div>

            <Grid
              container
              spacing={12}
              style={{
                paddingTop: "1rem",
                justifyContent: "space-between",
                width: "100%"
              }}
              className="reconcile_filter"
            >
              <Grid item xs={3}>
                <DataRangePicker
                  onSelect={range => this.onRangeSelect(range)}
                />
              </Grid>

              <Grid item xs={3}>
                <Dropdown
                  value={this.state.selectedStatus}
                  options={status}
                  label="Select Ticket Status"
                  type="text"
                  name="selectedStatus"
                  required
                  disableSelectOption={true}
                  fieldError={formErrors.ticketList}
                  handleChange={this.handleChange}
                  handleError={this.handleError}
                />
              </Grid>

              <Grid item xs={3}>
                <Dropdown
                  value={ticketListId}
                  options={this.showTicketList()}
                  label="Select Ticket Number"
                  type="text"
                  name="ticketListId"
                  required
                  fieldError={formErrors.ticketList}
                  handleChange={this.handleChange}
                  handleError={this.handleError}
                />
              </Grid>
            </Grid>
            <hr />
            <Grid container spacing={8}>
              <Grid item sm={6} xs={12}>
                <TicketDetails ticketDetails={ticketDetails} />
              </Grid>

              {/* <div class="vl"></div> */}

              <Grid item sm={6} xs={12}>
                <RecievedDetails
                  fieldError={formErrors.ticketList}
                  ticketListId={ticketListId}
                  isValid={isValid}
                  ReconciledData={ReconciledData}
                  reconciled={reconciled}
                  clearError={clearError}
                />
              </Grid>
            </Grid>
          </div>
        )}
      </div>
    ) : (
      <Forbidden />
    );
  }
}

function mapStateToProps(state) {
  return {
    // getTicketList: state.reconciliationReducer.ticketList
    getTicketList: state.reconciliationReducer.TicketList,
    getTicketDetails: state.reconciliationReducer.TicketDetails,
    reconciledData: state.reconciliationReducer.ReconciledData,
    SubFarmId: state.FarmManagementReducer.SubFarmId,
    MainFarmId: state.FarmManagementReducer.MainFarmId,
    selectedYear: state.harvestYearReducer.selectedYear
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      {
        getTicketList,
        getTicketDetails,
        getReconciledTicketDetails,
        emptyStateOnReconciliation
      },
      dispatch
    )
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Reconciliation);



// WEBPACK FOOTER //
// ./src/components/private/Reconciliation/Reconciliation.js